import { render, staticRenderFns } from "./UserGrantRole.vue?vue&type=template&id=5e0681e4&"
import script from "./UserGrantRole.vue?vue&type=script&lang=js&"
export * from "./UserGrantRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e0681e4')) {
      api.createRecord('5e0681e4', component.options)
    } else {
      api.reload('5e0681e4', component.options)
    }
    module.hot.accept("./UserGrantRole.vue?vue&type=template&id=5e0681e4&", function () {
      api.rerender('5e0681e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/users/views/UserGrantRole.vue"
export default component.exports